module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/van-active.6f080ba7.svg";